import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    gap: 10,
    flexDirection: "column",
  },
  alert: {
    "& .MuiAlert-message": {
      fontSize: 18,
      fontWeight: 900,
      color: theme.palette.text.primary,
    },
    height: 50,
    borderRadius: 0,
    borderLeft: "5px solid",
    width: "fit-content",
    alignItems: "center",
  },
  error: {
    borderLeftColor: theme.palette.error.main,
  },
  warning: {
    borderLeftColor: theme.palette.warning.main,
  },
}));
